exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#company-branding[data-v-49114d4a]{margin-top:80px}.page-title[data-v-49114d4a]{margin-bottom:20px}.table th[data-v-49114d4a]{border-top:none}.badge[data-v-49114d4a]{font-size:.75em}.btn-group .btn[data-v-49114d4a]{margin-right:2px}.btn-group .btn[data-v-49114d4a]:last-child{margin-right:0}", ""]);

// exports
